export default __webpack_public_path__ + "static/summer_containers92-6a5c0c5c8f292937eab68787ac201e08.webp";